import BrowerLogger from 'alife-logger';
const logger = (() => {
  console.log('logger当前环境====>', process.env.NODE_ENV);
  if (process.env.VUE_APP_ENV === 'prod') {
    try {
      return BrowerLogger.singleton({
        pid: 'bio0aqx9dv@bee814c930ed8d9',
        appType: 'web',
        imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
        sendResource: true,
        enableLinkTrace: true,
        behavior: true,
        enableSPA: true,
        parseHash: function(hash) {
          var page = hash ? hash.replace(/^#/, '').replace(/\?.*$/, '') : '';
          return page || '[index]';
        },
      });
    }
    catch (e) {
      console.error('init logger fail', e);
    }
  }
  else {
    return {
      error() {},
    };
  }
})();

export default logger;
